import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/sharp-solid-svg-icons';
import React from 'react';
import { twMerge } from 'tailwind-merge';

import { ButtonSize, ButtonVariant } from '@/components/button';
import IconButton from '@/components/button/iconButton';
import Typography from '@/components/typography';

type Props = {
  focus: boolean;
  index: number;
  value: React.ReactNode;
  onClick: () => void;
  onArrowClick?: () => void;
  onMouseEnter: () => void;
};

export const SearchElement: React.FC<Props> = ({
  focus,
  index,
  value,
  onClick,
  onArrowClick = undefined,
  onMouseEnter,
}) => {
  return (
    <div
      className={twMerge(
        'flex w-full cursor-pointer items-center justify-between bg-gray-10 px-4 py-1 hover:bg-gray-20 active:bg-gray-20',
        focus ? 'active focus bg-gray-20' : ''
      )}
      role="button"
      tabIndex={index}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          // TODO: This does nothing
          onClick();
        }
      }}
      onMouseEnter={onMouseEnter}
    >
      <Typography variant="body2">{value}</Typography>
      {onArrowClick && (
        <IconButton
          className="flex h-5 w-5 items-center justify-center p-2 hover:bg-gray-30"
          size={ButtonSize.SMALL}
          variant={ButtonVariant.GHOST}
          onClick={(e) => {
            e.stopPropagation();
            onArrowClick?.();
          }}
        >
          <FontAwesomeIcon icon={faChevronRight} size="sm" />
        </IconButton>
      )}
    </div>
  );
};
